/* eslint-disable react/sort-comp */
import React from 'react';
import { FixedSizeList as List, areEqual } from 'react-window';
import PropTypes from 'prop-types';

export default class Sidebar extends React.PureComponent {
    componentDidUpdate() {
        const { scrollTop } = this.props;
        this.sidebar.scrollTo(scrollTop);
    }

    Row = React.memo(
        ({ index, style, data }) => (
            <div style={{ ...style, ...this.styles.channelCellContainer }} pointerEvents="none">
                <img style={{ ...this.styles.logo }} src={data[index].channel.logoUrl} alt="" />
            </div>
        ),
        areEqual
    );

    render() {
        const { height, channels, theme } = this.props;
        return (
            <List
                className="list"
                width={theme.sidebar.container.width}
                height={height}
                itemCount={channels.length}
                itemData={channels}
                itemSize={theme.cell.container.height}
                style={{
                    // position: 'fixed',
                    overflow: 'hidden',
                    zIndex: 25,
                    boxShadow: '0 0 10px 0 rgba(0,0,0,0.5)'
                }}
                ref={(sidebar) => (this.sidebar = sidebar)}
            >
                {this.Row}
            </List>
        );
    }

    styles = {
        channelCellContainer: {
            ...this.props.theme.sidebar.container,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center'
        },
        text: {
            ...this.props.theme.sidebar.text
        },
        logo: {
            ...this.props.theme.sidebar.logo,
            maxHeight: this.props.theme.cell.height
        }
    };
}

Sidebar.propTypes = {
    scrollTop: PropTypes.number,
    height: PropTypes.number.isRequired,
    theme: PropTypes.object,
    channels: PropTypes.array
};

Sidebar.defaultProps = {
    scrollTop: null,
    theme: {},
    channels: []
};
